// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3eHEi","calendarButtons":"ClockData_calendarButtons__eJFck"};